import { render, staticRenderFns } from "./SubscriptionSidebar.vue?vue&type=template&id=95bec5be&scoped=true&"
import script from "./SubscriptionSidebar.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionSidebar.vue?vue&type=style&index=0&id=95bec5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bec5be",
  null
  
)

export default component.exports